import { Injectable } from "@angular/core";
import {
  AssetContent,
  AssetTreeViewModel,
  HelixAssetContentClient,
  HelixAssetTreeClient,
} from "@helix/client";
import { Store } from "@ngrx/store";
import { AppState } from "../store/reducers";
import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class AssetService {
  private readonly assetContent$Map: Map<number, Observable<AssetContent[]>> =
    new Map();

  constructor(
    private store: Store<AppState>,
    private assetContentClient: HelixAssetContentClient,
    private assetTreeClient: HelixAssetTreeClient,
  ) {}

  public getAssetContentById(
    assetId: number,
    filterId?: number,
  ): Observable<AssetContent[]> {
    if (this.assetContent$Map.has(assetId)) {
      return this.assetContent$Map
        .get(assetId)
        .pipe(map((assetContent) => this.filterByType(assetContent, filterId)));
    }

    const obs$ = this.assetContentClient.getById(assetId).pipe(shareReplay());
    this.assetContent$Map.set(assetId, obs$);
    return obs$.pipe(
      map((assetContent) => this.filterByType(assetContent, filterId)),
    );
  }

  private filterByType(
    assetContent: AssetContent[],
    filterId: number,
  ): AssetContent[] {
    if (!filterId) {
      return assetContent;
    }
    return assetContent.filter(
      (value) => value.assetContentTypeId === filterId,
    );
  }

  public getEnrichedAssetTree(): Observable<AssetTreeViewModel[]> {
    return this.assetTreeClient.get();
  }
}
